import { DoqFaceSvgProps } from '../types';

const TimelineError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g clipPath="url(#clip0_2698_48912)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-timeline-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#FCBF4C"
        mask="url(#bottom-mask-timeline-error)"
      />
      <mask
        id="mask0_2353_64583"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_2353_64583)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#2974C4"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#2974C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159 200C153.078 200 147.907 203.217 145.141 208L150.056 208C152.253 205.545 155.446 204 159 204C162.554 204 165.747 205.545 167.944 208L172.859 208C170.093 203.217 164.922 200 159 200Z"
        fill="#2974C4"
      />
      <path d="M80 144H240V152H80V144Z" fill="#92DBD3" />
      <path d="M80 152H240V160H80V152Z" fill="#2974C4" />
      <path d="M80 136H240V144H80V136Z" fill="#2974C4" />
      <g opacity="0.5">
        <path
          d="M96 232C91.5817 232 88 235.582 88 240V296C88 300.418 91.5817 304 96 304H99L99 258.236C98.3862 257.687 98 256.889 98 256C98 255.111 98.3863 254.313 99 253.764L99 232H96Z"
          fill="#2974C4"
        />
        <path
          d="M99.5 232L99.5 253.401C99.9413 253.146 100.454 253 101 253H131V232H99.5Z"
          fill="#2974C4"
        />
        <path
          d="M131.5 232V253H162V247H140C138.343 247 137 245.657 137 244C137 242.343 138.343 241 140 241H162V232H131.5Z"
          fill="#2974C4"
        />
        <path d="M162.5 232V241H193V232H162.5Z" fill="#2974C4" />
        <path d="M193.5 232V241H224V232H193.5Z" fill="#2974C4" />
        <path
          d="M224.5 232.015V241H232V240C232 235.75 228.685 232.273 224.5 232.015Z"
          fill="#2974C4"
        />
        <path d="M232 247H224.5V253H232V247Z" fill="#2974C4" />
        <path
          d="M232 259H224.5V265.041C225.919 265.28 227 266.514 227 268C227 269.486 225.919 270.72 224.5 270.959V289H232V259Z"
          fill="#2974C4"
        />
        <path
          d="M232 295H224.5V303.985C228.685 303.727 232 300.25 232 296V295Z"
          fill="#2974C4"
        />
        <path d="M224 304V295H193.5V304H224Z" fill="#2974C4" />
        <path d="M193 304V295H162.5V304H193Z" fill="#2974C4" />
        <path d="M162 304V295H131.5V304H162Z" fill="#2974C4" />
        <path
          d="M131 304V295H109C107.343 295 106 293.657 106 292C106 290.343 107.343 289 109 289H131V283H121C119.343 283 118 281.657 118 280C118 278.343 119.343 277 121 277H131V271H109C107.343 271 106 269.657 106 268C106 266.343 107.343 265 109 265H131V259H101C100.454 259 99.9413 258.854 99.5 258.599L99.5 304H131Z"
          fill="#2974C4"
        />
        <path d="M193.5 247H224V253H193.5V247Z" fill="#2974C4" />
        <path d="M193.5 259H224V265H193.5V259Z" fill="#2974C4" />
        <path
          d="M193.5 271H224V289H193.5V283H209C210.657 283 212 281.657 212 280C212 278.343 210.657 277 209 277H193.5V271Z"
          fill="#2974C4"
        />
        <path d="M193 289V283H162.5V289H193Z" fill="#2974C4" />
        <path d="M193 277V271H162.5V277H193Z" fill="#2974C4" />
        <path d="M193 265V259H162.5V265H193Z" fill="#2974C4" />
        <path d="M193 253V247H162.5V253H193Z" fill="#2974C4" />
        <path d="M131.5 259H162V265H131.5V259Z" fill="#2974C4" />
        <path d="M131.5 271H162V277H131.5V271Z" fill="#2974C4" />
        <path d="M131.5 283H162V289H131.5V283Z" fill="#2974C4" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2698_48912">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { TimelineError };
